import React, { useState, useEffect, useRef } from 'react';

import { useDragScroll } from '../PublicStatistic/hooks/useDragScroll';
import FilterDropdown from '../PublicStatistic/FilterDropdown';


import { 
  Container, 
  Table, 
  Pagination,
  Form,
  Navbar,
  Nav
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSort,
  faSortUp,
  faSortDown,
  faXmark
} from '@fortawesome/free-solid-svg-icons';
import './ApplicationsPage.css';

import { getRequestsList } from './actions';
import { requestword } from '../../components/helpers/wordsnumber';

const tableInfo = { 
  headers: [
    "Ім'я дитини",
    "Свідоцтво",
    "Подано",
    "Надсилати з",
    "Статус",
    "Обрані садочки",
    "Пільги"
  ], 
  fields: [ 
    "name", 
    "certificate", 
    "submitted", 
    "sendFrom", 
    "status",
    "zdoCount",
    "benefitsStatus"
  ] 
};

// Типы данных для каждого поля (для корректной сортировки та підказок у пошуку)
const fieldTypes = {
  name: 'text',
  certificate: 'text',
  submitted: 'date',
  sendFrom: 'date',
  status: 'text',
  zdoCount: 'number',
  benefitsStatus: 'text'
};

// Поля, для яких доступний пошук у розрізі колонки.
const columnSearchableFields = ['name', 'certificate', 'submitted', 'sendFrom', 'status', 'zdoCount', 'benefitsStatus'];
const sortableFields = ['name', 'certificate', 'submitted', 'sendFrom', 'status', 'zdoCount', 'benefitsStatus'];

const list_filters = [
  {field:"filter_selected_zdo", label:"Тільки з обраними закладами", sh_label: "Обрані ЗДО"},
  {field:"filter_benefits", label:"Тільки пільгові", sh_label: "Пільгові"},
  {field:"filter_owner", label:"Мої заявки", sh_label: "Мої"},
]

// Опції для спільного компонента FilterDropdown (мультивибір):
// value/label — для пункту меню, shortLabel — коротка назва для тексту кнопки.
const filterOptions = list_filters.map(f => ({
  value: f.field,
  label: f.label,
  shortLabel: f.sh_label,
}));

const ApplicationsPage = () => {
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [applicationsData, setApplicationsData] = useState([]);
  const [allcount, setAllCount] = useState(0);
  const [isLoad, setLoad] = useState(false);
  const [sort, setSort] = useState({sortBy: "submitted", directBy: "desc"});
  const [activeFilters, setActiveFilters] = useState({
    filter_selected_zdo: false,
    filter_benefits: false,
    filter_owner: false
  });
  const [columnFilters, setColumnFilters] = useState({});
  // Текст, який реально показується в полях пошуку по колонках (контрольовані інпути) —
  // окремо від columnFilters, щоб хрестик міг очищати поле миттєво, без очікування дебаунсу.
  const [columnFilterInputs, setColumnFilterInputs] = useState({});

  const timeoutRef = useRef(null);
  const columnTimeoutRefs = useRef({});


  const { ref: scrollRef, listeners: dragListeners } = useDragScroll();

  // Функция для получения иконки сортировки
  const getSortIcon = (fieldName) => {
    if (fieldName !== sort.sortBy) return faSort;
    return sort.directBy === 'asc' ? faSortUp : faSortDown;
  };

  // Функция для получения типа поля
  const getFieldType = (fieldName) => {
    return fieldTypes[fieldName] || 'text';
  };

  const updSort = (i) => {
    const fieldName = tableInfo.fields[i];
    if (!sortableFields.includes(fieldName)) return;
    let newDirection;
    
    if (fieldName !== sort.sortBy) {
      newDirection = 'asc';
    } else {
      newDirection = sort.directBy === 'asc' ? 'desc' : 'asc';
    }
    
    setSort({sortBy: fieldName, directBy: newDirection});
  }

  const updData = async () => {
    if(isLoad) return;
    setLoad(true);

    const {all_count, data } = await getRequestsList({
      search, 
      page, 
      pageSize, 
      sortBy: sort.sortBy, 
      sortDirection: sort.directBy,
      filters: activeFilters,
      columnFilters,
      date_from: '2019-01-01'
    });

    setApplicationsData(data);
    setAllCount(all_count);
    setLoad(false);
  }

  const handleChange = (e) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setPage(0);
      setSearch(e.target.value);
    }, 500);
  };

  // Дебаунсований обробник введення тексту в пошук по конкретній колонці
  const handleColumnFilterChange = (fieldName, value) => {
    setColumnFilterInputs(prev => ({
      ...prev,
      [fieldName]: value
    }));

    if (columnTimeoutRefs.current[fieldName]) {
      clearTimeout(columnTimeoutRefs.current[fieldName]);
    }

    columnTimeoutRefs.current[fieldName] = setTimeout(() => {
      setPage(0);
      setColumnFilters(prev => ({
        ...prev,
        [fieldName]: value
      }));
    }, 500);
  };

  // Миттєве очищення пошуку по одній колонці (хрестик), без очікування дебаунсу
  const clearColumnFilter = (fieldName) => {
    if (columnTimeoutRefs.current[fieldName]) {
      clearTimeout(columnTimeoutRefs.current[fieldName]);
    }

    setColumnFilterInputs(prev => ({
      ...prev,
      [fieldName]: ''
    }));
    setColumnFilters(prev => {
      if (!(fieldName in prev)) return prev;
      const next = { ...prev };
      delete next[fieldName];
      return next;
    });
    setPage(0);
  };

  // Функция для переключения фильтров
  const toggleFilter = (filterName) => {
    setActiveFilters(prev => ({
      ...prev,
      [filterName]: !prev[filterName]
    }));
    setPage(0); // Скидаємо на першу сторінку при зміні фільтра
  };

  // Функция для скидання всіх фільтрів
  const clearAllFilters = () => {
    setActiveFilters({
      filter_selected_zdo: false,
      filter_benefits: false,
      filter_owner: false
    });
    setPage(0);
  };

  useEffect(() => { 
    updData(); 
  }, [page, search, pageSize, sort, activeFilters, columnFilters]);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      Object.values(columnTimeoutRefs.current).forEach(t => t && clearTimeout(t));
    };
  }, []);

  const columnFilterPlaceholders = {
    date: 'Пошук...',
    number: 'Пошук...'
  };

  const ArrPage = Array.from({length: Math.ceil(allcount/pageSize) }, (_, i) => i);

  return (
    <div className="applications-page">
      <main className="main-content">
        <Container>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h1 className="mb-3">Всі заявки</h1>
              <p className="text-muted">Тут ви можете знайти інформацію про подані заявки та їх статуси</p>
            </div>
          </div>

          {/* Controls */}
          <div className="d-flex justify-content-between align-items-center mb-4 applications-controls">
            <FilterDropdown
              mode="multi"
              options={filterOptions}
              value={Object.keys(activeFilters).filter(k => activeFilters[k])}
              onChange={(field) => toggleFilter(field)}
              placeholder="Фільтри не застосовані"
              renderSelectedLabel={(selected) =>
                selected.length
                  ? `Застосовано: ${selected.map(o => o.shortLabel || o.label).join(', ')}`
                  : 'Фільтри не застосовані'
              }
              onClear={clearAllFilters}
              clearLabel="Скинути всі фільтри"
            />

            <div className="search-box">
              <i className="fas fa-search search-icon"></i>
              <Form.Control 
                type="text" 
                placeholder="Пошук за номером свідоцтва про народження..." 
                className="applications-search"
                onChange={handleChange}
              />
            </div>
          </div>

          {/* Table */}
          <div
            ref={scrollRef}
            className="table-responsive"
            style={{ cursor: 'grab', overflowX: 'auto' }}
            {...dragListeners}
          >
            <Table className="applications-table">
              <thead className="table-header">
                <tr>
                 {tableInfo.headers.map((lab, i) => {
                   const fieldName = tableInfo.fields[i];
                   const isSortable = sortableFields.includes(fieldName);
                   return (
                     <th 
                       key={i} 
                       onClick={isSortable ? () => updSort(i) : undefined}
                       className="applications-table-header"
                       style={{ cursor: isSortable ? 'pointer' : 'default', userSelect: 'none' }}
                     >
                       <div className="d-flex align-items-center">
                         {lab}
                         {isSortable && (
                           <FontAwesomeIcon 
                             icon={getSortIcon(fieldName)}
                             className="ms-1"
                             style={{ fontSize: '12px' }}
                           />
                         )}
                       </div>
                     </th>
                   );
                 })}
               </tr>
               <tr className="applications-column-filters">
                 {tableInfo.fields.map((fieldName, i) => (
                   <th key={fieldName} onClick={(e) => e.stopPropagation()}>
                     {columnSearchableFields.includes(fieldName) && (
                       <div className="applications-column-search-wrapper" style={{ position: 'relative' }}>
                         <Form.Control
                           type="text"
                           size="sm"
                           placeholder={columnFilterPlaceholders[fieldTypes[fieldName]] || 'Пошук...'}
                           className="applications-column-search"
                           style={{ paddingRight: '24px' }}
                           value={columnFilterInputs[fieldName] || ''}
                           onChange={(e) => handleColumnFilterChange(fieldName, e.target.value)}
                         />
                         {!!columnFilterInputs[fieldName] && (
                           <button
                             type="button"
                             className="applications-column-search-clear"
                             aria-label="Очистити"
                             onClick={() => clearColumnFilter(fieldName)}
                             style={{
                               position: 'absolute',
                               right: '6px',
                               top: '50%',
                               transform: 'translateY(-50%)',
                               border: 'none',
                               background: 'transparent',
                               padding: '2px',
                               lineHeight: 0,
                               color: '#6c757d',
                               cursor: 'pointer'
                             }}
                           >
                             <FontAwesomeIcon icon={faXmark} style={{ fontSize: '12px' }} />
                           </button>
                         )}
                       </div>
                     )}
                   </th>
                 ))}
               </tr>
              </thead>
              <tbody>
                {applicationsData.map((application) => (
                  <tr 
                    key={application.id}
                    className={application.note ? 'own-application-row' : ''}
                    title={application.note ? 'Це ваша заявка' : undefined}
                  >
                    <td>
                      <a href="#" className="child-name-link">{application.name}</a>
                    </td>
                    <td>{application.certificate}</td>
                    <td>{application.submitted}</td>
                    <td>{application.sendFrom}</td>
                    <td>
                      <span className={`status ${application.statusClass}`}>
                        {application.status}
                      </span>
                    </td>
                    <td>{application.zdoCount}</td>
                    <td>{application.benefitsStatus}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          {/* Pagination */}
          <div className="d-flex align-items-center mt-4 pagination-wrapper">
            <div className="pagination-info">Всього {allcount} {requestword(allcount)}</div>
            { ( ArrPage.length > 1 ) &&  (
              <Pagination className="applications-pagination">
                <Pagination.Prev onClick={page > 0 ? () => setPage(page - 1) : () => {}}>
                  <span aria-hidden="true">&lt;</span>
                </Pagination.Prev>
                { ArrPage.slice(page - (page % 5), page + (5 - page % 5)).map((v) => (
                  <Pagination.Item 
                    key={v} 
                    active={v === page} 
                    onClick={() => setPage(v)}
                  >
                    {v + 1}
                  </Pagination.Item>
                )) }
                <Pagination.Next onClick={page < ArrPage.length - 1 ? () => setPage(page + 1) : () => {}}>
                  <span aria-hidden="true">&gt;</span>
                </Pagination.Next>
              </Pagination>
            )}
          </div>
        </Container>
      </main>
    </div>
  );
};

export default ApplicationsPage;